import { useCallback, useEffect, useState } from "react";
import {
  getAccountantAnalyticsAPI,
  getAccountantInvoicesAPI,
  getAccountantSubscriptionsAPI,
} from "../../../utils/api/billing";

const initial = { status: "loading", data: null, error: "" };

// Loads one accountant dataset and reloads it whenever its params change.
// Each dataset has its own params so changing, e.g., the analytics year does
// not refetch the payment table.
function useBillingResource(load, token, params, reloadKey) {
  const [state, setState] = useState(initial);
  const paramsKey = JSON.stringify(params);
  useEffect(() => {
    if (!token) return undefined;
    let cancelled = false;
    setState((current) => ({ ...current, status: "loading", error: "" }));
    load(token, JSON.parse(paramsKey))
      .then((res) => {
        if (!cancelled) setState({ status: "ready", data: res.data, error: "" });
      })
      .catch((e) => {
        if (!cancelled) setState({ status: "error", data: null, error: e.message });
      });
    return () => {
      cancelled = true;
    };
  }, [load, token, paramsKey, reloadKey]);
  return state;
}

export default function useAccountantBilling({ storeId = "", invoiceFilters = {}, analyticsPeriod = {} } = {}) {
  const token = localStorage.getItem("auth-token");
  const [reloadKey, setReloadKey] = useState(0);
  const reload = useCallback(() => setReloadKey((key) => key + 1), []);

  const subscriptions = useBillingResource(getAccountantSubscriptionsAPI, token, { storeId }, reloadKey);
  const invoices = useBillingResource(getAccountantInvoicesAPI, token, { storeId, ...invoiceFilters }, reloadKey);
  const analytics = useBillingResource(getAccountantAnalyticsAPI, token, { storeId, ...analyticsPeriod }, reloadKey);

  return { token, subscriptions, invoices, analytics, reload };
}
